import { appEnv } from '@/components/adv-components';
import type { h5ComponentsType } from '@/components/adv-components/adv-common-container/types';
import { defaultGeoInfo } from '@/constant/system';

/** 挽留弹窗封装，需要对配置的任务做检验 */
const leavingPush = (masterId:string, useDefaultGeo?: boolean):void => {
  const advEvt = useDefaultGeo ? { geo: defaultGeoInfo } : {};

  import(/* webpackChunkName: "h5-components" */'@hb/h5-components').then((advMaster) => {
    const { advMasterApi } = advMaster as unknown as h5ComponentsType;
    advMasterApi.getBannerInfos(masterId, appEnv, {
      ...advEvt,
    }).then((adxData) => {
      /** creative 非空数组 才命中任务 */
      if (adxData && adxData.adm.length && adxData.adm[0].creative
        && adxData.adm[0].creative.length) {
        window.history.pushState(null, '挽留弹窗', window.location.href);
      }
    });
  });
};

export const HistoryManager = {
  leavingPush,
};
